import * as React from "react";
import Checkbox from "../../generic/checkbox";
import "../../../assets/scss/components/login/generic/loginSecureImg.scss";

export interface ILoginSecureImgProps {
	imgSrc: string;
	checked: boolean;
	onCheckboxChange: (checked: boolean) => void;
	className?: string;
}

const LoginSecureImg: React.FC<ILoginSecureImgProps> = props => {
	return (
		<div className={"secure_img_cont " + (props.className || "")}>
			<span>
				<img src={props.imgSrc} alt="" />
				<label className="secure_img_txt">This is my secure access image</label>
			</span>
			<Checkbox checked={props.checked} name="securityImg" onChange={e => props.onCheckboxChange(e.target.checked)} />
		</div>
	);
};

export default LoginSecureImg;
